import { Redirect, Route, RouteProps } from "react-router-dom";
import { useSessionContext } from "@newHooks/context/session/session.context";

interface AuthRouteProps extends RouteProps {
  authStrategy?: "AUTHORIZED_ONLY" | "UNAUTHORIZED_ONLY";
  denyRedirectTo?: string;
}

export function AuthRoute({ children, authStrategy, denyRedirectTo = "/auth", render, component: Comp, ...rest }: AuthRouteProps) {
  const { session } = useSessionContext();

  const Component: any = Comp;
  const available = (() => {
    if (authStrategy) {
      switch (authStrategy) {
        case "AUTHORIZED_ONLY":
          return !!session && !!session.token;
        case "UNAUTHORIZED_ONLY":
          return !session || !session.token;
        default:
          throw new Error("Unexpected Usage");
      }
    }

    return !!session && !!session.token;
  })();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!available) return <Redirect to={{ pathname: denyRedirectTo, state: { from: props.location } }} />;

        if (render) {
          return render({ ...props });
        }

        return <Component {...props} />;
      }}
    />
  );
}
